<!--File: cgp-confirmation-dialog.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/28/2017-->
<!--Desc: CGP Confirmation Dialog.-->
<!--Other Contributors:-->

<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
    <div [innerHTML]="message" class="{{alert ? 'alert alert-' + alert : ''}}"></div>
</div>

<div mat-dialog-actions class="cgp-dialog-actions">
    <span class="cgp-flex-fill"></span>
    <button mat-raised-button color="primary" (click)="handleYesClick()">{{yesLabel}}</button>
    <button mat-raised-button (click)="handleNoClick()">{{noLabel}}</button>
    <button mat-raised-button (click)="handleCancelClick()" *ngIf="cancelButton">Cancel</button>
</div>